import { CachedRecentSearch } from '@/redux/api/saveSearch';
import { GlobalState } from '@/redux/store';
import { SearchParams } from '@/types/SaveSearch';
import { getKeywordFromQueryParams, parseQueryParams } from '@/utils/queryParams';

export type SaveSearchParamsOrKey = SearchParams | string;

const normalizeRecentSearchKeyword = (keyword: string) => keyword.trim().toLowerCase();

export const getRecentSearchKeywordFromParams = (saveSearchParams: SaveSearchParamsOrKey): string => {
    if (typeof saveSearchParams === 'string') {
        return saveSearchParams.trim();
    }

    const keyword = saveSearchParams.keyword;

    return typeof keyword === 'string' ? keyword.trim() : String(keyword ?? '').trim();
};

export const getRecentSearchQuery = (recentSearch: CachedRecentSearch): string => {
    const keywordFromFacets = getKeywordFromQueryParams(recentSearch.facets);

    if (keywordFromFacets) {
        return String(keywordFromFacets);
    }

    const queryString = recentSearch.url.includes('?') ? recentSearch.url.split('?')[1] : '';
    const keywordFromUrl = getKeywordFromQueryParams(parseQueryParams(queryString));

    return keywordFromUrl ? String(keywordFromUrl) : '';
};

export const isKeywordInRecentSearches = (state: GlobalState, keyword: string): boolean => {
    const normalizedKeyword = normalizeRecentSearchKeyword(keyword);

    if (!normalizedKeyword) {
        return false;
    }

    return state.saveSearch.recentSearches.some(({ facets, url }) => {
        const query = getRecentSearchQuery({ facets, hash: '', url });

        return normalizeRecentSearchKeyword(query) === normalizedKeyword;
    });
};
